
import { Alert, Space } from 'antd';

export default function OldCmsContent({name}) {
	return (
		<Space size="large" direction='vertical' style={{width: '100%'}} >
			<h1>{`Homepage > ${name}`}</h1>
      <Alert
        description={
            <p>This section corresponds to the cards displayed on the Multimedia Centre homepage.<br/>
            To modify or edit the information displayed on them, please contact the Vidneo support team.</p>
        }
        type="info"
      />
		</Space>
	);
}